module.exports = __webpack_public_path__ + "static/media/maps-proto.d9c785f8.mov";